import { render } from 'views/client';
import View from '.';

render(View);



// WEBPACK FOOTER //
// ./src/views/batting-position-leaders/batting-position-leaders.js